import React from 'react';
import ProductImage from '../../../common/ProductImage';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { IconWrapper } from '../../../common/IconWrapper';

export default function BestwayTransactionLine({ line }) {
    const numberToPrice = numberField => {
        return '£' + numberField.toFixed(2);
    };

    return (
        <tr>
            <td>
                <ProductImage src={line.image} alt={'Brandbank image for ' + line.productDescription} />
            </td>
            <td>{line.productCode}</td>
            <td>
                <p>{line.productDescription.toUpperCase()}</p>
                <p className={'barcode'}>{line.barcode}</p>
            </td>
            <td>{line.unitSize}</td>
            <td>{numberToPrice(line.invoiceCost)}</td>
            <td className={'centered'}>{line.quantity}</td>
            <td className={'centered'}>
                <IconWrapper icon={faCheck} className={'valid'} />
            </td>
        </tr>
    );
}
